import { errorNotifier, successNotifier } from '../../../components/NotificationHandler';
import http, { AUTH_ROUTES } from '../../../services/api';

export const addErrandSubscription = async (payload, setLoading, setFormValues, initialValues, onClose) => {
  try {
    await http.post(AUTH_ROUTES.CREATE_ERRAND_SUBSCRIPTION, payload);
    setLoading(false);
    setFormValues(initialValues);
    successNotifier('Errand Subcription Successfully created');
    onClose();
  } catch (e) {
    setLoading(false);
    errorNotifier(e.response?.data.result);
  }
};
